// frontend/src/pages/MrpList.tsx
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
const list = () => fetch("/api/v1/mrp.production", { headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } }).then(r => r.json()).then((r: any) => r.ok ? r.data : []);
const act = (id: number, a: string) => fetch(`/api/v1/mrp.production/${id}/${a}`, { method: "POST", headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } });
const stateColors: Record<string, string> = { draft:"bg-gray-100 text-gray-700", confirmed:"bg-blue-100 text-blue-700", progress:"bg-yellow-100 text-yellow-700", done:"bg-green-100 text-green-700", cancel:"bg-red-100 text-red-700" };
export default function MrpList() {
  const qc = useQueryClient();
  const { data: orders } = useQuery({ queryKey: ["mrp"], queryFn: list });
  const cu = (fn: any) => useMutation({ mutationFn: fn, onSuccess: () => qc.invalidateQueries({ queryKey: ["mrp"] }) });
  const confirmMut = cu((id: number) => act(id, "confirm"));
  const startMut = cu((id: number) => act(id, "start"));
  const finishMut = cu((id: number) => act(id, "finish"));
  return <div>
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-2xl font-bold">Manufacturing Orders</h1>
      <Link to="/manufacturing/new" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">+ New MO</Link>
    </div>
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 border-b">
          <tr><th className="text-left px-4 py-3 font-medium text-gray-600">Ref</th><th className="text-left px-4 py-3 font-medium text-gray-600">Product</th><th className="text-right px-4 py-3 font-medium text-gray-600">Qty</th><th className="text-center px-4 py-3 font-medium text-gray-600">State</th><th className="text-right px-4 py-3 font-medium text-gray-600">Actions</th></tr>
        </thead>
        <tbody className="divide-y">
          {orders?.map((o: any) => (
            <tr key={o.id} className="hover:bg-gray-50">
              <td className="px-4 py-3 font-medium">{o.name}</td>
              <td className="px-4 py-3 text-gray-600">{o.product_id ?? "—"}</td>
              <td className="px-4 py-3 text-right">{o.product_qty}</td>
              <td className="px-4 py-3 text-center"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${stateColors[o.state] ?? ""}`}>{o.state}</span></td>
              <td className="px-4 py-3 text-right space-x-2">
                {o.state === "draft" && <button onClick={() => confirmMut.mutate(o.id)} className="text-blue-600 hover:text-blue-800 text-xs font-medium">Confirm</button>}
                {o.state === "confirmed" && <button onClick={() => startMut.mutate(o.id)} className="text-yellow-600 hover:text-yellow-800 text-xs font-medium">Start</button>}
                {o.state === "progress" && <button onClick={() => finishMut.mutate(o.id)} className="text-green-600 hover:text-green-800 text-xs font-medium">Finish</button>}
                {(o.state === "draft" || o.state === "confirmed") && <button onClick={() => {}} className="text-red-600 hover:text-red-800 text-xs font-medium">Cancel</button>}
              </td>
            </tr>
          ))}
          {(!orders || orders.length === 0) && <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-400">No manufacturing orders</td></tr>}
        </tbody>
      </table>
    </div>
  </div>;
}
